import { SmartSegment } from 'shared/api/common/schemas/smartSegments'
import { mapResponse } from 'shared/api/lib/mapResponse'
import { smartSegmentApi } from 'shared/api/requests/smartSegments'
import { createListSlice } from 'shared/lib/factory/redux/createListSlice'
import { createListOperations } from 'shared/lib/factory/redux/createListSlice/lib/createListOperations'

const getId = (smartSegment: SmartSegment) => smartSegment.segment_id
const operations = createListOperations({
  getList: mapResponse(smartSegmentApi.getList, (response) => {
    return response.data
  }),
  getNextList: undefined,
  getPrevList: undefined,
  createItem: undefined,
  updateItem: undefined,
  deleteItem: (args: number) => {
    return smartSegmentApi.delete({ body: { smart_segment_id: args } })
  },
})

export const {
  actions: smartSegmentsActions,
  reducer: smartSegmentsReducer,
  selectors: smartSegmentsSelectors,
  initialState: smartSegmentsInitialState,
} = createListSlice({
  namespace: 'smartSegments',
  storePath: 'smartSegments.list',
  listKey: 'segments',
  operations,

  getItemId: getId,
  extraState: {},
  reducers: {},
})
